
<script>
/*
 * 全局公用常量和方法
 * author by leiyang	2018.10.19
 * */
	
	let pageSize = 10
	let cycleTime = [
		{'value': 1,'label': '00:00 AM'},
  		{'value': 2,'label': '01:00 AM'},
  		{'value': 3,'label': '02:00 AM'},
  		{'value': 4,'label': '03:00 AM'},
  		{'value': 5,'label': '04:00 AM'},
  		{'value': 6,'label': '05:00 AM'},
  		{'value': 7,'label': '06:00 AM'},
  		{'value': 8,'label': '07:00 AM'},
  		{'value': 9,'label': '08:00 AM'},
  		{'value': 10,'label': '09:00 AM'},
  		{'value': 11,'label': '10:00 AM'},
  		{'value': 12,'label': '11:00 AM'},
  		{'value': 13,'label': '12:00 PM'},
  		{'value': 14,'label': '01:00 PM'},
  		{'value': 15,'label': '02:00 PM'},
  		{'value': 16,'label': '03:00 PM'},
  		{'value': 17,'label': '04:00 PM'},
  		{'value': 18,'label': '05:00 PM'},
  		{'value': 19,'label': '06:00 PM'},
  		{'value': 20,'label': '07:00 PM'},
  		{'value': 21,'label': '08:00 PM'},
  		{'value': 22,'label': '09:00 PM'},
  		{'value': 23,'label': '10:00 PM'},
  		{'value': 24,'label': '11:00 PM'}
	]

	  export default
	  {
	    pageSize,
	    cycleTime
	  }
</script>



// WEBPACK FOOTER //
// Global.vue?e7869c1e